// Ensure intl-tel-input search box has proper padding
const ensureIntlTelInputStyle = () => {
  if (document.getElementById('iti-search-style')) return
  const style = document.createElement('style')
  style.id = 'iti-search-style'
  style.innerHTML = `.iti__search-input { padding-left: 2.5rem !important; }`
  document.head.appendChild(style)
}

// Initialize international phone number inputs with country selector
const initPhoneInputs = () => {
  const phoneInputs = Array.from(document.querySelectorAll('input[id$="_phone"]'))
  if (phoneInputs.length === 0 || typeof window.intlTelInput !== 'function') return

  ensureIntlTelInputStyle()

  const options = {
    initialCountry: 'my',
    separateDialCode: true,
    autoPlaceholder: 'polite',
    preferredCountries: ['my', 'sg'],
    excludeCountries: ['il', 'kp'],
    nationalMode: false,
    loadUtils: () =>
      import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.10.10/build/js/utils.js'),
  }

  phoneInputs.forEach((telInput) => {
    const iti = window.intlTelInput(telInput, options)
    const form = telInput.form || document

    const updatePhoneValue = () => {
      const updatedFullPhone = iti.getNumber()
      telInput.value = updatedFullPhone
    }

    form.addEventListener('submit', updatePhoneValue)
  })
}

// Toggle visibility of "Other" text fields when "Others" is selected in dropdowns
const initOtherInputs = () => {
  const otherInputs = document.querySelectorAll('input[id$="_other"]')

  otherInputs.forEach((otherInput) => {
    const mainInputId = otherInput.id.replace('_other', '')
    const mainInput = document.getElementById(mainInputId) || document.getElementById(`${mainInputId}_id`)
    const radioInputs = document.querySelectorAll(
      `input[name="user[${mainInputId.replace('user_', '')}]"]`
    )
    if (!mainInput && radioInputs.length === 0) return

    const wrapperId = `${otherInput.id.replace('user_', '')}_wrapper`
    const wrapper = document.getElementById(wrapperId) || otherInput.closest(`.${otherInput.id}`)
    if (!wrapper) return

    const toggleVisibility = () => {
      let isOtherSelected = false

      if (mainInput?.type === 'hidden') {
        const value = mainInput.value?.toLowerCase() || ''
        isOtherSelected = value === 'others' || value.includes('other')
      } else if (mainInput?.tagName === 'SELECT') {
        const selectedOption = mainInput.options[mainInput.selectedIndex]
        const text = selectedOption?.text?.toLowerCase() || ''
        const value = mainInput.value?.toLowerCase() || ''
        isOtherSelected = text.includes('other') || value === 'others'
      } else if (radioInputs.length > 0) {
        const checked = Array.from(radioInputs).find((input) => input.checked)
        const value = checked?.value?.toLowerCase() || ''
        isOtherSelected = value === 'others' || value.includes('other')
      }

      if (isOtherSelected) {
        wrapper.classList.remove('hidden')
        otherInput.disabled = false
        otherInput.required = true
      } else {
        wrapper.classList.add('hidden')
        otherInput.disabled = true
        otherInput.required = false
        otherInput.value = ''
      }
    }

    if (mainInput?.tagName === 'SELECT') {
      mainInput.addEventListener('change', toggleVisibility)
    }

    radioInputs.forEach((input) => {
      input.addEventListener('change', toggleVisibility)
    })

    toggleVisibility()
  })
}

// Enable submit button only when all required consent checkboxes are checked
const initPdpaCheckbox = () => {
  const consentChecks = Array.from(document.querySelectorAll('.js-registration-consent'))
  const checkboxes = consentChecks.length > 0
    ? consentChecks
    : Array.from(document.querySelectorAll('#pdpa_checkbox'))
  const submitBtn = document.getElementById('signup-submit-btn')
  if (checkboxes.length === 0 || !submitBtn) return

  const syncSubmitState = () => {
    submitBtn.disabled = !checkboxes.every((checkbox) => checkbox.checked)
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', syncSubmitState)
  })

  syncSubmitState()
}

// Show selected filename next to custom file upload buttons
const initFileNameDisplay = () => {
  const fileNameLabels = Array.from(document.querySelectorAll('.js-file-name'))
  if (fileNameLabels.length === 0) return

  fileNameLabels.forEach((label) => {
    const inputId = label.dataset.targetInput
    const input = document.getElementById(inputId)
    if (!input) return

    const syncFileName = () => {
      label.textContent = input.files?.[0]?.name || 'No file chosen'
    }

    input.addEventListener('change', syncFileName)
    syncFileName()
  })
}

// Make passport upload required for non-Malaysian users
const initPassportRequired = () => {
  const countrySelect = document.getElementById('user_country')
  const passportInput = document.getElementById('user_passport_upload')
  const isEditPage = !!document.getElementById('current-passport')
  if (!countrySelect || !passportInput) return

  const updatePassportRequired = () => {
    const selectedCountryName = countrySelect.options[countrySelect.selectedIndex]?.text
    passportInput.required = isEditPage ? false : selectedCountryName !== 'Malaysia'
  }

  countrySelect.addEventListener('change', updatePassportRequired)
  if (countrySelect.value) updatePassportRequired()
}

// Smooth scroll to first invalid field on form submission
const initFormValidation = () => {
  const form = document.querySelector('form#new_user, form[id^="edit_user"]')
  if (!form) return

  form.addEventListener('submit', (e) => {
    if (form.checkValidity()) return

    e.preventDefault()
    e.stopPropagation()

    const firstInvalid = form.querySelector(':invalid')
    if (!firstInvalid) return

    const NAVBAR_HEIGHT = document.querySelector('nav')?.offsetHeight || 80
    const BANNER_HEIGHT = document.querySelector('.page-hero')?.offsetHeight || 120
    const EXTRA_PADDING = 20
    const offset = NAVBAR_HEIGHT + BANNER_HEIGHT + EXTRA_PADDING
    const y = firstInvalid.getBoundingClientRect().top + window.pageYOffset - offset

    window.scrollTo({ top: y, behavior: 'smooth' })
    setTimeout(() => firstInvalid.focus({ preventScroll: true }), 600)
  })
}

// Initialize all user form functionality
const initUser = () => {
  const userForm = document.querySelector('form#new_user, form[id^="edit_user"]')
  if (!userForm) return

  initPhoneInputs()
  initOtherInputs()
  initPdpaCheckbox()
  initFileNameDisplay()
  initPassportRequired()
  initFormValidation()
}

export default initUser
